module.exports = __webpack_public_path__ + "static/media/001.14b23cc2.webp";